import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3aee28aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stich" }
const _hoisted_2 = { class: "stichparent" }


import CardComponent from "./CardComponent.vue";
import { store } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'StichComponent',
  props: {
  cards: Array,
},
  setup(__props) {



const play = () => {
//   const game = store.game;
//   if (game.getStage() === GameStage.STOCK && game.getPlaying()) {
//     store.table.hand = store.table.hand.filter((c) => card.id !== c.id);
//     store.table.stock.push(card);
//   }
//   if (game.getStage() === GameStage.SPIEL) {
//     store.table.hand = store.table.hand.filter((c) => card.id !== c.id);
//     if (game.getTurn()) this.playCard(card);
//     else window.alert("Du bist nicht dran!");
//   }
    store.game.claimStich()
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.cards, (card, index) => {
        return (_openBlock(), _createBlock(CardComponent, {
          key: card.id,
          id: card.id,
          index: index,
          rotate: true,
          animate: false,
          onClick: ($event: any) => (play(card))
        }, null, 8, ["id", "index", "onClick"]))
      }), 128))
    ])
  ]))
}
}

})